<template>
  <div>
    <headerCard />
    <router-view></router-view>
  </div>
</template>

<script>
import headerCard from "./header.vue";
export default {
  name: "Layout",
  components: { headerCard },
};
</script>

<style>
</style>